import {store} from '../../App';
import config from '../../config';

import * as Artwork from './artwork';

let axios   = require('axios'),
    io      = require('../io/index').actions,
    i18n    = require('i18next');

export const actiontypes = {
  TRACK_CREATE_SUCCESS: 'TRACK_CREATE_SUCCESS',
}
export const actions = {
  createTrack: (track) => {
    return dispatch => {
      dispatch(io.loading());
      let messages = i18n.t('io', {returnObjects: true}).tracks.track.create;

      axios.post(`${config.API_ADDRESS}/track`,
        track
      , {
        headers: {
          'Authorization': `Bearer ${store.getState().session.token}`
        }
      })
      .then(res => res.data)
      .then(json => {
        dispatch(trackCreateSuccess(json));
        dispatch(io.message(messages.success,'success', false));

        if (track._image)
          dispatch(Artwork.actions.uploadTrackArtwork(json, track._image));

      })
      .catch(err => dispatch(io.message(`${messages.error} (${err.message})`, 'error', false)));

    }
  }
}

function trackCreateSuccess(track) {
  return {
    type: actiontypes.TRACK_CREATE_SUCCESS,
    track
  }
}



// WEBPACK FOOTER //
// ./src/actions/tracks/create.js